import { render, staticRenderFns } from "./doodles-page.vue?vue&type=template&id=f26cef94&scoped=true&lang=pug&"
import script from "./doodles-page.vue?vue&type=script&lang=js&"
export * from "./doodles-page.vue?vue&type=script&lang=js&"
import style0 from "./doodles-page.vue?vue&type=style&index=0&id=f26cef94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26cef94",
  null
  
)

export default component.exports